"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const veflux_1 = require("vasat/dist/src/veflux");
const stream_data_service_1 = require("../stream-data.service");
class TreeNodeBuilder {
    constructor(_streams) {
        this._streams = _streams;
    }
    get streams() {
        return this._streams;
    }
    fromFolder(f) {
        return new FolderNode(f).setBuilder(this);
    }
    fromAccount(a) {
        return new AccountNode(a).setBuilder(this);
    }
    fromAccountProjects(a) {
        return new ProjectsNode(a).setBuilder(this);
    }
    fromFolderWithFiles(f, expanded = false, selectabledFiles = false) {
        return new FolderFileNode(f, expanded, selectabledFiles).setBuilder(this);
    }
    fromJobType(f, mapData) {
        return new JobTypeNode(f, mapData).setBuilder(this);
    }
    fromJob(f) {
        return new JobNode(f).setBuilder(this);
    }
    fromFile(f, selectable = false) {
        return new FileNode(f, selectable).setBuilder(this);
    }
    fromStaticInfo(name, items, expand = true) {
        return new StaticNode(name, items, expand).setBuilder(this);
    }
}
exports.TreeNodeBuilder = TreeNodeBuilder;
/**
 * tree node is a wrapper for anything you want put in a tree
 */
class TreeNode {
    constructor(caption, expanded = false, ref, selectable = false) {
        this.caption = caption;
        this.expanded = expanded;
        this.ref = ref;
        this.selectable = selectable;
        this._children = new veflux_1.ArrayStore(TreeEvent);
        this._subs = [];
    }
    set redraw(fn) {
        this._refdraw = fn;
    }
    get children() {
        return this._children;
    }
    get isLeaf() { return false; }
    get hasChildren() { return false; }
    setBuilder(tnb) {
        this._builder = tnb;
        return this;
    }
    load() { }
    unload() {
        this._subs.forEach(s => s.unsubscribe());
    }
    loadChildren() {
        throw new Error('not Implemented');
    }
}
exports.TreeNode = TreeNode;
class StaticNode extends TreeNode {
    constructor(name, byoChildren, expand) {
        super(name, expand, name);
        this.byoChildren = byoChildren;
    }
    get isLeaf() { return false; }
    get hasChildren() { return this.byoChildren.length > 0; }
    loadChildren() {
        return rxjs_1.of(this.byoChildren).pipe(operators_1.tap(c => this.children.values = c));
    }
}
class AccountNode extends TreeNode {
    constructor(a) {
        super(a.name, true, a);
        this.a = a;
    }
    loadChildren() {
        return this.a.vasat.searchByObject(_4d_mapper_1.Folder)
            .equals("account", this.a.id)
            .equals("active", true)
            .isNull("forProject")
            .isNull("parent")
            .useCache(true)
            .limit(100)
            .queryObservable().pipe(operators_1.map(r => this.children.values = r.items.map(i => this._builder.fromFolder(i))));
    }
    get hasChildren() { return true; }
}
class ProjectsNode extends TreeNode {
    constructor(a) {
        super(a.name, false, a);
        this.a = a;
    }
    loadChildren() {
        return this.a.vasat.searchByObject(_4d_mapper_1.Folder)
            .equals("account", this.a.id)
            .equals("active", true)
            .isNotNull("forProject")
            .useCache(true)
            .limit(100)
            .queryObservable().pipe(operators_1.map(r => this.children.values = r.items.map(i => this._builder.fromFolder(i))));
    }
    get hasChildren() { return true; }
}
class FolderNode extends TreeNode {
    constructor(f, expanded = false) {
        super(f.name, expanded, f);
        this.f = f;
    }
    load() {
        this._subs.push(this._builder.streams.folderEvents.pipe(operators_1.filter(f => f.item == this.f)).subscribe(f => {
            this.caption = f.item.name;
            if (this._refdraw)
                this._refdraw(f);
        }));
    }
    initChildListener() {
        this._subs.push(this._builder.streams.folderEvents.pipe(operators_1.filter(f => f.item.parent.id == this.f.id && this.hasChildren)).subscribe(f => {
            if (f.event == 'ADD') {
                this.children.add(this._builder.fromFolder(f.item));
            }
            else if (f.event == 'REMOVE') {
                this.children.values = this.children.values.filter(c => c.ref != f.item);
            }
        }));
    }
    loadChildren() {
        this.initChildListener();
        return this.f.vasat.searchByObject(_4d_mapper_1.Folder)
            .equals('parent', this.f.id)
            .equals('active', true)
            .useCache(true)
            .sortBy('name')
            .queryObservable().pipe(operators_1.map(r => this.children.values = r.items.map(i => this._builder.fromFolder(i))));
    }
    get hasChildren() { return this.f['folder_count']; }
}
/**
 * Contains both sub folders and files in the tree
 */
class FolderFileNode extends FolderNode {
    constructor(f, expanded, selectableFiles = false) {
        super(f, expanded);
        this.selectableFiles = selectableFiles;
    }
    loadChildren() {
        this.initChildListener();
        this._subs.push(this._builder.streams.fileEvents.pipe(operators_1.filter(f => f.item.folder.id == this.f.id && this.hasChildren)).subscribe(f => {
            if (f.event == 'ADD') {
                this.children.add(this._builder.fromFile(f.item));
            }
            else if (f.event == 'REMOVE') {
                this.children.values = this.children.values.filter(c => c.ref != f.item);
            }
        }));
        var folders = this.f.vasat.searchByObject(_4d_mapper_1.Folder)
            .equals('parent', this.f.id)
            .equals('active', true)
            .useCache(true)
            .sortBy('name')
            .queryObservable().pipe(operators_1.map(r => r.items.map(i => this._builder.fromFolderWithFiles(i, false, this.selectableFiles))));
        var files = this.f.vasat.searchByObject(_4d_mapper_1.Dataset)
            .equals("folder", this.f.id)
            .equals("active", true)
            .useCache(true)
            .limit(100)
            .queryObservable().pipe(operators_1.map(r => r.items.map(i => {
            return this._builder.fromFile(i, this.selectableFiles);
        })));
        return rxjs_1.combineLatest([folders, files]).pipe(operators_1.map(([folderRes, fileRes]) => folderRes.concat(fileRes))).pipe(operators_1.map(r => this.children.values = r));
    }
    get hasChildren() { return this.f['folder_count'] || this.f['file_count']; }
}
exports.FolderFileNode = FolderFileNode;
class JobTypeNode extends TreeNode {
    constructor(jt, mapData) {
        super(jt.name, false, jt);
        this.jt = jt;
        this.mapData = mapData;
    }
    loadChildren() {
        // idea is if the tree is rendered as theres changes to a job, let this class know
        this._subs.push(this.mapData.sceneJobs.events.pipe(operators_1.filter(ev => ev.item.jobType.id == this.jt.id)).subscribe(ev => {
            if (ev.event == 'ADD') {
                this.children.set(new JobNode(ev.item));
            }
            else if (ev.event == 'REMOVE') {
                var tn = this.children.values.find(v => v.ref == ev.item);
                this.children.remove(tn);
            }
            else {
                var tn = this.children.values.find(v => v.ref == ev.item);
                if (ev.item.active)
                    this.children.emmit(tn, 'UPDATE');
                else
                    this.children.remove(tn);
            }
        }));
        return rxjs_1.of(this.mapData.sceneJobs.values.filter(j => j.jobType.id == this.jt.id).map(j => this._builder.fromJob(j))).pipe(operators_1.map(a => this.children.values = a));
    }
    get hasChildren() { return true; }
}
class FileNode extends TreeNode {
    constructor(f, selectableFile = false) {
        super(f.name, false, f, selectableFile);
        this.f = f;
    }
    get isLeaf() { return true; }
}
class JobNode extends TreeNode {
    constructor(f) {
        super(f.name, false, f);
        this.f = f;
    }
    get isLeaf() { return true; }
}
class TreeEvent extends veflux_1.BaseEvent {
}
exports.TreeEvent = TreeEvent;
